jQuery(document).ready(function($) {
  require('./components/mobile-header.js')
  require('./components/accordion.js')
  require('./components/video.js')
  require('./components/slider.js')

  utility.init();

  jQuery(window).on('scroll', function() {
    if(window.pageYOffset > 1) {
      jQuery('header').addClass('scroll-active')
    } else {
      jQuery('header').removeClass('scroll-active')
    }
  })


  // Revers Order of ul
  ul = $('#my-ul'); // your parent ul element
  ul.children().each(function(i,li){ul.prepend(li)})


  // Click Active
  $(document).on('click','.single-member', function () {
     $(this).children('.single-member-title-container').toggleClass('active');
    });

});


var utility = {
    init: function() {
      utility.hashAnimate();
    },

    hashAnimate: function() {
        jQuery("*[href*=#]").click(function(e) {
            e.preventDefault();

            var localHash = jQuery(this).attr('href');
            var scrollOffset = jQuery('header').outerHeight();

            jQuery("html, body").animate({
                scrollTop: jQuery(localHash).offset().top - scrollOffset - 80
            }, 200);
        });
    }
}


//# sourceMappingURL=scripts.min.js.map
